import { gpHome } from '../app';
import { AccountsService } from '../services/accounts-service';
import { refusalMessage } from './confirm-refusal';

interface IConfirmEmailScope extends ng.IScope {
    password: string;
    confirmationSuccessful: boolean;
    confirmationResending: boolean;
    confirmationResent: boolean;
    confirmationResentError: boolean;
    confirmationError: string | null;
    confirming: boolean;
    confirm(): void;
    resendEmail(): void;
}

gpHome.controller(
    'confirmemailController',
    ['$scope', 'accountsService', '$routeParams',
        function ($scope: IConfirmEmailScope, accountsService: AccountsService, $routeParams: ng.route.IRouteParamsService) {

            let userId = $routeParams['userId'];
            let code = $routeParams['code'];

            $scope.password = '';

            $scope.resendEmail = () => {
                $scope.confirmationResending = true;

                accountsService.resendEmail(userId)
                    .then(() => $scope.confirmationResent = true)
                    .catch(value => $scope.confirmationResentError = value)
                    .finally(() => $scope.confirmationResending = false)
                    ;
            };

            // Only on a click, never on load: the link alone must not confirm, and
            // mail scanners open links.
            $scope.confirm = () => {
                $scope.confirming = true;
                $scope.confirmationError = null;

                accountsService.confirmEmail(userId, code, $scope.password)
                    .then(() => $scope.confirmationSuccessful = true)
                    .catch(value => $scope.confirmationError = refusalMessage(value))
                    .finally(() => $scope.confirming = false);
            };
        }]);
